export default __webpack_public_path__ + "static/media/defs.96b475cf.svg";